import VueX from '@/store';
const Driver = () => import('@/modules/driver');

export default [
  {
    path: '/franquia/entregadores/:id/faturas',
    name: 'driver-invoices',
    component: Driver,
  },
  {
    path: '/franquia/entregadores/:id/pedidos',
    name: 'driver-orders',
    component: Driver,
  },
  {
    path: '/franquia/entregadores/:id',
    name: 'driver',
    component: Driver,
    meta: { 
      navbarTitle: () => VueX.getters['driver/actual'].full_name,
      drawerComponent: () => import('@/modules/driver/_components/BankFormBase'),
      nameCity: true,
    },
  },
  {
    path: '/franquia/entregadores/:id/lojas',
    name: 'driver-assigned-stores',
    component: Driver,
    meta: {   
      navbarTitle: 'Lojas atribuídas',
      nameCity: true,
    },
  },
  {
    path: '/franquia/entregadores/:id/ocorrencias',
    name: 'driver-occurrences',
    component: Driver,
    meta: {  
      navbarTitle: () => VueX.getters['driver/actual'].full_name,
      nameCity: true,
      onlyCheckBoxClick: true,
    },
  },
];
